import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from "react-redux";
import { fontesExternasAction, logAction } from '../_actions';
import { withRouter, Link } from 'react-router-dom';
import { history } from '../_helpers';
import { stringUtils } from '../_utils';
import {
    Breadcrumb, BreadcrumbItem, Card, CardBody, CardHeader, Button, UncontrolledTooltip, Container, Row, Col, FormGroup, Label, Input, Form, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import InputMask from "react-input-mask";
import { NavBar } from '../_components/navbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo, faCheck } from '@fortawesome/free-solid-svg-icons';
import '././styles.css';
import { ModalLog } from '../log/';

const FontesExternasEdit = (props) => {

    const dispatch = useDispatch();

    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    useEffect(() => {
        const { match: { params } } = props;

        if (params.id) {
            dispatch(fontesExternasAction.getFonteExternaById(params.id));
        } else {
            dispatch(fontesExternasAction.clear());
        }

    }, []);

    const handleChange = prop => event => {
        dispatch(fontesExternasAction.onChangeProps(prop, event));
    };

    const handleSubmit = event => {

        event.preventDefault();
        const { match: { params } } = props;

        if (props.fonteExterna.nome === null || props.fonteExterna.nome === '') {
            alert('Informe um Nome válido!');
        } else if (props.fonteExterna.link === null || props.fonteExterna.link === '') {
                alert('Informe um Link válido!');
        } else {

            let payload = {
                id: params.id ? params.id : 0,
                nome: props.fonteExterna.nome,
                link: props.fonteExterna.link,
                linkAcumulado: props.fonteExterna.linkAcumulado,
            };

            if (params.id) {
                dispatch(fontesExternasAction.editFonteExternaInfo(params.id, payload));
            } else {
                dispatch(fontesExternasAction.createFonteExterna(payload));
            }

        }

    };

    const handleClickHistory = event => {

        event.preventDefault();
        const { match: { params } } = props;

        if (params.id) {
            dispatch(logAction.getLog('FonteExterna', params.id));
            toggle();
        }

    };

    const { log } = props.log;

    return (
        <div>
            <NavBar />
            <Container>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col md={12}>
                                <Breadcrumb>
                                    <BreadcrumbItem><Link to="/fontesExternas" href="">Lista de Fontes Externas</Link></BreadcrumbItem>
                                    <BreadcrumbItem active>{(props.fonteExterna.id > 0 ? props.fonteExterna.nome : 'Nova')}</BreadcrumbItem>
                                    {props.fonteExterna.id > 0 ?
                                        <BreadcrumbItem className="pb-0 pt-0 m-0 btn btn-muted">
                                            <a href="#" id="tagHistorico" onClick={(event) => handleClickHistory(event)}>Histórico</a>
                                            <UncontrolledTooltip placement="bottom" target="tagHistorico">
                                                Exibe o histórico de alterações do registro
                                            </UncontrolledTooltip>
                                        </BreadcrumbItem>
                                    : null}
                                </Breadcrumb>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={(event) => handleSubmit(event)}>
                            <Row>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label className="left" for="nome">Nome *</Label>
                                        <Input
                                            id="nome"
                                            label="Nome"
                                            maxLength="60"
                                            required={true}
                                            className="form-control text-uppercase"
                                            value={props.fonteExterna.nome}
                                            onChange={handleChange('nome')}
                                            onInput={stringUtils.toInputUppercase}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label className="left" for="link">Link *</Label>
                                        <Input
                                            id="link"
                                            label="Link"
                                            maxLength="150"
                                            required={true}
                                            className="form-control"
                                            value={props.fonteExterna.link || ''}
                                            onChange={handleChange('link')}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label className="left" for="linkAcumulado">Link Pluviometria *</Label>
                                        <Input
                                            id="linkAcumulado"
                                            label="Link Acumulado"
                                            maxLength="150"
                                            required={true}
                                            className="form-control"
                                            value={props.fonteExterna.linkAcumulado || ''}
                                            onChange={handleChange('linkAcumulado')}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                            </Row>    
                            <br />
                            <Row>
                                <Col className="left" md="8" lg="6">
                                    <span>* Campos obrigatórios</span>
                                </Col>
                                <Col className="d-flex flex-row-reverse" md="4" lg="6">
                                    <Button variant="contained" color="primary" type="submit">Salvar <FontAwesomeIcon icon={faCheck} /></Button>
                                    <Button className="mr-1" variant="contained" color="secondary" component='a' onClick={() => history.push("/fontesExternas/")} href="">Voltar <FontAwesomeIcon icon={faUndo} /></Button>
                                 </Col>
                            </Row>
                        </Form>
                    </CardBody>
                </Card>
            </Container>
            <ModalLog toggle={toggle} modal={modal} log={log} />
        </div>
    );

};

const mapStateToProps = (state) => {
    return state;
};

const connectedFontesExternasEditPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(FontesExternasEdit));
export { connectedFontesExternasEditPage as FontesExternasEdit };